import { throwConfigError, useEditorConfig } from "../../../EditorConfig"
import { useCustomTypes } from "../../service/customType"
import { useAPIExplorer } from "../components/APIExplorerContext"

export function useRequestRepositoryCustomTypes(nonRepeatableOnly?: boolean) {
  const { request } = useAPIExplorer()

  const config = useEditorConfig()
  if (!("customTypesApiBaseUrl" in config)) {
    throwConfigError("customTypesApiBaseUrl")
  }

  const { customTypesApiBaseUrl, authStrategy } = config

  return useCustomTypes({
    baseUrl: customTypesApiBaseUrl,
    repository: request.repository.id,
    authStrategy,
  }).data.filter((type) => !nonRepeatableOnly || !type.repeatable)
}
